import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pointing-view"
}
const _hoisted_2 = {
  key: 0,
  class: "pi pi-times-circle"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "pi pi-times"
}

import { PointingModelFragment } from "@/graphql/types";
import { toTimeData } from "@/utils/times";
import moment from "moment";
import { computed } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'PointingView',
  props: {
    viewOption: {},
    pointing: {},
    date: {}
  },
  emits: ["create-pointing", "update-pointing"],
  setup(__props: any) {


const props = __props;

const { d, t } = useI18n();
//check if date is tomorrow using moment js
const resume = computed(() => {
  const times = toTimeData(props.pointing?.previous?.times).concat(
    toTimeData(props.pointing?.times)
  );
  const momentDate = moment(props.date);
  const _times = times.map((time) => {
    let entry = "";
    const _entry = moment(time.entry);
    if (_entry.isSame(moment(props.date), "day")) {
      entry = _entry.format("HH:mm");
    }
    let exit = "";
    if (time.exit) {
      const _exit = moment(time.exit);
      exit = _exit.isSame(moment(props.date), "day")
        ? _exit.format("HH:mm")
        : "";
    }
    return { entry, exit };
  });

  return {
    times: _times,
    tooltips: times
      .map(
        (time) =>
          `${
            time.entry ? `- ${t("hr_entry")} : ${d(time.entry, "long")}` : ""
          } ${time.exit ? `\n- ${t("hr_exit")} : ${d(time.exit, "long")}` : ""}`
      )
      .join("\n"),
    isFuture: momentDate.isAfter(moment()),
    isTomorrow: momentDate.isSame(moment(), "day"),
  };
});

return (_ctx: any,_cache: any) => {
  const _component_Tag = _resolveComponent("Tag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.pointing)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (_ctx.viewOption === 'icon')
          ? _withDirectives((_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "pi pi-check-circle p-success cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update-pointing', _ctx.pointing)))
            }, null, 512)), [
              [_directive_tooltip, resume.value.tooltips]
            ])
          : (_ctx.viewOption === 'label')
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "p-success cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-pointing', _ctx.pointing)))
              }, [
                _createTextVNode(" P ")
              ])), [
                [_directive_tooltip, resume.value.tooltips]
              ])
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "p-d-flex p-flex-column p-ai-center p-jc-center cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update-pointing', _ctx.pointing))),
                style: {"gap":"3px"}
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resume.value.times, (time) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: time.entry.toString()
                  }, [
                    (time.entry)
                      ? (_openBlock(), _createBlock(_component_Tag, {
                          key: 0,
                          value: time.entry,
                          seveity: "success",
                          rounded: ""
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true),
                    (time.exit)
                      ? (_openBlock(), _createBlock(_component_Tag, {
                          key: 1,
                          value: time.exit,
                          severity: "danger",
                          rounded: ""
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
      ]))
    : (!resume.value.isFuture)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('create-pointing'))),
          class: "cursor-pointer p-error"
        }, [
          (_ctx.viewOption === 'icon')
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : (_ctx.viewOption === 'label')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "A"))
              : (_openBlock(), _createElementBlock("i", _hoisted_4))
        ]))
      : _createCommentVNode("", true)
}
}

})